<template>
  <v-layout v-if="!isExercisesFetched" column justify-center align-center class="mt-5">
    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    <p class="subheading-1 mt-5 primary--text font-weight-bold">Downloading Exercises...</p>
  </v-layout>

  <v-layout v-else column>
    <h3 class="font-weight-medium mb-4">Exercises</h3>
    <v-layout
      v-if="!getExercises.length"
    >There are no exercises available for your grade at the moment.</v-layout>
    <v-layout v-else wrap>
      <v-flex
        xs12
        sm4
        xl3
        v-for="exercise in getExercises"
        :key="exercise.exerciseId"
        class="mb-5 prsCard bb"
      >
        <v-card
          class="pcard white--text"
          :class="exercise.completed ? 'completed' : ''"
          @click="exercise.completed ? '' : $router.push('/exercises/'+exercise.exerciseId)"
        >
          <v-chip v-if="exercise.premium" class="caption premium-tag gold--text">
            <v-icon small class="mr-1" color="gold">mdi-star</v-icon>Premium
          </v-chip>
          <v-card-actions class="body-2 font-weight-regular">
            <v-layout column>
              <v-flex>{{exercise.exerciseTitle}}</v-flex>
              <v-flex v-if="exercise.completed">[Completed]</v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-if="!getUserDetails.premium && getPremiumSnips.length">
      <PremiumModal :premiumDialog="premiumDialog" @close="premiumDialog = false"/>
      <h3 class="font-weight-medium mt-6 mb-4 gold--text">
        <v-icon color="gold" class="mr-2">mdi-star-circle</v-icon>Premium Exercises
      </h3>
      <!-- Snippets - If user is not premium -->
      <v-layout wrap>
        <v-flex
          md4
          lg3
          xl3
          v-for="exercise in getPremiumSnips"
          :key="exercise.exerciseId"
          class="mb-5 prsCardPrem bb"
        >
          <v-card class="pcard white--text" @click="premiumDialog = true">
            <v-chip class="caption premium-tag gold--text">
              <v-icon small class="mr-1" color="gold">mdi-star</v-icon>Premium
            </v-chip>
            <v-card-actions class="body-2 font-weight-regular">
              <v-layout column>
                <v-flex>{{exercise.exerciseTitle}}</v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
import PremiumModal from "@/components/PremiumModal";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      premiumDialog: false
    };
  },
  components: { PremiumModal },
  computed: {
    ...mapGetters([
      "getExercises",
      "isExercisesFetched",
      "getPremiumSnips",
      "getUserDetails"
    ])
  },
  methods: {
    ...mapActions(["fetchExercises"])
  },
  created() {
    if (!this.isExercisesFetched) {
      this.fetchExercises();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isExercisesFetched) return;
    return next();
  }
};
</script>

<style>
.bb {
  box-sizing: border-box;
}
.theme--light.v-chip:not(.v-chip--active) {
  background-color: #fff;
}
.premium-tag {
  position: absolute;
  text-shadow: none;
  top: -10px;
  right: -10px;
  padding: 6px 14px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
}

.prsCardPrem .pcard {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 130px;
  max-width: 330px;
  margin: 10px;
  box-sizing: border-box;
  padding: 75px 20px 0 10px;
  border-radius: 8px;
  text-shadow: 1px 1px 1px #000000;
  transition: all 0.3s;
  cursor: pointer;
  background: url("../assets/card-bg.svg"), linear-gradient(rgb(214, 136, 46));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(216, 137, 59, 0.2);
  -moz-box-shadow: 0px 5px 24px 0px rgba(216, 137, 59, 0.2);
  box-shadow: 0px 5px 24px 0px rgba(216, 137, 59, 0.2);
}
.prsCard .pcard {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 130px;
  max-width: 330px;
  margin: 10px;
  box-sizing: border-box;
  padding: 65px 20px 0 10px;
  border-radius: 8px;
  text-shadow: 1px 1px 1px #000000;
  transition: all 0.3s;
  cursor: pointer;
}

.prsCard .pcard:hover {
  transform: translateY(-5px);
}

.prsCard:nth-child(5n + 1) .pcard {
  background: url("../assets/card-bg.svg"),
    linear-gradient(rgba(234, 35, 64, 1));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(234, 35, 64, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(234, 35, 64, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(234, 35, 64, 0.3);
}

.prsCard:nth-child(5n + 2) .pcard {
  background: url("../assets/card-bg.svg"), linear-gradient(rgba(45, 45, 68, 1));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(45, 45, 68, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(45, 45, 68, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(45, 45, 68, 0.3);
}

.prsCard:nth-of-type(5n + 3) .pcard {
  background: url("../assets/card-bg.svg"),
    linear-gradient(rgba(243, 172, 19, 1));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(243, 172, 19, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(243, 172, 19, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(243, 172, 19, 0.3);
}
.prsCard:nth-of-type(5n + 4) .pcard {
  background: url("../assets/card-bg.svg"), linear-gradient(rgb(146, 201, 29));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(153, 216, 21, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(153, 216, 21, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(153, 216, 21, 0.3);
}

.prsCard:nth-of-type(5n + 5) .pcard {
  background: url("../assets/card-bg.svg"),
    linear-gradient(rgba(47, 194, 223, 1));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(47, 194, 223, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(47, 194, 223, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(47, 194, 223, 0.3);
}

.prsCard:nth-of-type(5n + 6) .pcard {
  background: url("../assets/card-bg.svg"), linear-gradient(rgb(238, 72, 155));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(252, 64, 205, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(252, 64, 205, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(252, 64, 205, 0.3);
}

.prsCard:nth-of-type(5n + 7) .pcard {
  background: url("../assets/card-bg.svg"), linear-gradient(rgb(133, 86, 219));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(109, 47, 223, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(109, 47, 223, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(109, 47, 223, 0.3);
}

.prsCard .completed.pcard {
  background: url("../assets/card-bg.svg"), linear-gradient(rgb(92, 92, 92));
  -webkit-box-shadow: 0px 5px 24px 0px rgba(92, 92, 92, 0.3);
  -moz-box-shadow: 0px 5px 24px 0px rgba(92, 92, 92, 0.3);
  box-shadow: 0px 5px 24px 0px rgba(92, 92, 92, 0.3);
}

.prsCard .completed.pcard:hover {
  transform: translateY(0);
}
</style>
